<div class="ui-g page-header-c">
    <div class="ui-g-12 ui-md-6 ui-lg-6">
      <h1 class="page-title" translate>label_manage_shift_title</h1>
    </div>
</div>
<div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
    <div class="dispatch-request-tabs">
        <p-tabMenu [model]="items" [activeItem]="activeItem"></p-tabMenu>
        <router-outlet (activate)="componentAdded($event)" (deactivate)="componentRemoved($event)"></router-outlet>
    </div>
</div>